import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OrderHeader } from '../../_models/orderHeader';
import * as _ from "lodash";
import { StockShipmentLine } from '../../_models/stockShipmentLine';
import { OrderLine } from '../../_models/orderLine';
import { AlertService } from '../../_services/alert.service';
import { User } from "../../_models/user";
import { DatePipe } from '@angular/common';
import { PayService } from '../../_services/pay.service';

@Component({
  selector: 'app-order-processing',
  templateUrl: './order-processing.component.html',
  styleUrls: ['./order-processing.component.scss'],
  providers: [DatePipe]
})
export class OrderProcessingComponent implements OnInit {
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  invoiceReason: string;
  getCreditsAmount: any;
  shipType: string;
  package: any = [];
  step: number = 1;
  url: any;
  others: boolean = false;
  othersDisplay: string;
  easyShip: any;
  slotsList: any;
  razorPayData: any;
  totalBoxes: number = 0;
  boxHeights: number = 0;
  boxWidths: number = 0;
  boxLengths: number = 0;
  numberOfBoxes: string;
  paymentMode: string;
  orderAmount: string;
  invoiceUrl: string;
  amount: string;
  amountError: any;
  printInvoicePopUp: string = 'N';
  creditBalancePopup: string = 'N';
  shippingList: any = [];
  tabClicked = "packing";
  stockShipLines: Array<StockShipmentLine>;
  allShipLines: Array<StockShipmentLine>;
  stockShipLine: StockShipmentLine = {};
  configLineIdSeq: number = 1;
  totalWeight: number;
  productConfig: string;
  orderStatusValue: string;
  singleBoxWeightTemp: number;
  packagesList = [];
  dimensions: any;
  shippingCost: any = [];
  numberOfBoxesM: string;
  order: OrderHeader = {};
  reviewOrder: any = {};
  boxesCount: number = 0;
  costEstimation: any;
  costEstimateList: any = {};
  errorMessage1: string;
  carrierName: string;
  carrierNameError: string;
  shippedDate: string;
  shippedDateError: string;
  shipmentCostOther: string;
  AWBNumber: string;
  shipmentCostOtherError: string;
  shipmentDateChange: string;
  trackingURL: string;

  constructor(private alertService: AlertService, private payService: PayService, private datePipe: DatePipe, public st: OrderHeader, public user: User, private http: HttpClient, private g: Globals, private route: ActivatedRoute,
    private router: Router, private api: ApiIntegration) {
    this.reviewOrder.productConfig = "MULTI_SKU";
    this.getOrderData();
    this.numberOfBoxesM = "1";
  }

  getOrderData() {
    this.g.loaderDisplay = "display";
    this.api.getOrderDataById(this.route.snapshot.params['id'], this.user.accountOwnerId, "1").subscribe((data: OrderHeader) => {
      this.g.loaderDisplay = "";
      this.reviewOrder = data;
      if(this.reviewOrder.paymentMethod == 'ppd'){
        this.reviewOrder.paymentMethod = 'prepaid'
      }
      this.dimensions = data.shipLines;
      if (!this.reviewOrder.productConfig) {
        this.reviewOrder.productConfig = "MULTI_SKU";
      }
      this.changeBox();
      if (this.reviewOrder.orderStatus == "PRINT_INVOICE" || this.reviewOrder.orderStatus == "SKIP_INVOICE") {
        if (this.reviewOrder.channelName == "FLIPKART") {
          this.step = 2;
        } else if (this.reviewOrder.fullFilledBy == "EASYSHIP") {
          this.tabClicked = 'carrier';
          this.getSlotsList();
        } else {
          this.tabClicked = 'carrier';
          this.costEstimate();
        }
      }
    }, err => {
      this.alertService.error('Error', err);
    });
    this.packageApi();
  }

  ngOnInit() {
  }

  packageApi() {
    this.api.getPackingTypesListAccount(this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.package = data.getPackingTypesResponses;
      this.package.push({ packingType: 'Custom', height: '', width: '', lenght: '', weight: '' });
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  printInvoice() {
    this.g.loaderDisplay = 'display';
    this.api.downloadCustInvoice(this.user.accountOwnerId, this.reviewOrder.orderHeaderId, "1").subscribe((data: any) => {
      this.g.loaderDisplay = '';
      if (data['code'] == 200) {
        window.open(data['additionalInfo'], '_blank');
        if (this.reviewOrder.channelName == "FLIPKART") {
          this.step = 2;
        } else {
          this.tabClicked = 'carrier';
          this.costEstimate();
        }
      } else {
        this.statusText13 = '';
        this.printInvoicePopUp = 'Y';
      }
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  addShipmentLine(o) {
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    if (!Number(o.qtyPerBoxTmp) || o.qtyPerBoxTmp === null || o.qtyPerBoxTmp === undefined) {
      this.statusText2 = 'Please enter quantity';
    }
    if (!Number(o.numOfBoxesTmp) || o.numOfBoxesTmp === null || o.numOfBoxesTmp === undefined) {
      this.statusText3 = 'Please enter no.of boxes';
    }
    if (o.packageType === null || o.packageType === undefined) {
      this.statusText4 = 'Please select package type';
    }
    if (o.boxHeight === null || o.boxHeight === undefined || o.boxLength === null || o.boxLength === undefined || o.boxWidth === null || o.boxWidth === undefined) {
      this.statusText5 = 'Please enter l*w*h';
    }
    if (o.quantityWeight === null || o.quantityWeight === undefined) {
      this.statusText6 = 'Please enter weight';
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "") {
      return false;
    }
    if (o != null) {
      this.stockShipLines = (_.cloneDeep(o.shipLines));
      if (this.stockShipLines == null) {
        this.stockShipLines = [];
      }
      this.stockShipLine.numberOfBoxes = o.numOfBoxesTmp;
      this.stockShipLine.quantityPerBox = o.qtyPerBoxTmp;
      this.stockShipLine.productId = o.productId;
      this.stockShipLine.packageType = o.packageType;
      this.stockShipLine.orderLineId = o.orderLineId;
      this.stockShipLine.configLineId = this.configLineIdSeq;
      this.stockShipLine.boxHeight = o.boxHeight;
      this.stockShipLine.boxWidth = o.boxWidth;
      this.stockShipLine.boxLength = o.boxLength;
      this.stockShipLine.boxWeight = o.boxWeight;
      this.stockShipLine.quantityWeight = o.quantityWeight;
      this.stockShipLine.totalWeight = o.totalWeight || this.totalWeight;
      this.stockShipLine.productWeight = o.productWeight;
      this.stockShipLine.totalQuantity = (o.numOfBoxesTmp * o.qtyPerBoxTmp);
      this.stockShipLines.push(_.cloneDeep(this.stockShipLine));
      o.shipLines = _.cloneDeep(this.stockShipLines);
      let boxWg = 0;
      o.shipLines.forEach((ele) => {
        if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
          boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
      });
      o.totalQuantity = boxWg;
      o.numOfBoxesTmp = null;
      o.qtyPerBoxTmp = null;
      o.boxHeight = null;
      o.packageType = undefined;
      o.boxWidth = null;
      o.boxLength = null;
      o.boxWeight = null;
      o.productWeight = o.productWeight;
      ;
      this.stockShipLine = {};
      this.configLineIdSeq = this.configLineIdSeq + 1;
    }
  }

  showShipIcon(row) {
    this.statusText7 = "";
    let show = false;
    let totalQuantity = 0;
    totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    }
    if (row.quantity != totalQuantity) {
      this.statusText7 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
      show = false;
    }
    return show;
  }

  showAddShipRow(row) {
    let show = false;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    } else {
      this.statusText8 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
    }
    return show;
  }

  showAddShipmentBtn(row) {
    this.statusText9 = "";
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = false;
    }
    totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
    if (row.quantity < totalQuantity) {
      this.statusText9 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
      show = false;
    }
    return show;
  }

  populateDimensions(row) {
    if (row.packageType) {
      let index = this.package.findIndex((d) => d.packingType === row.packageType);
      if (index > -1) {
        row.boxHeight = this.package[index].height;
        row.boxWidth = this.package[index].width;
        row.boxLength = this.package[index].length;
      }
    }
  }

  fieldsEntered(row) {
    let show = true;
    let textEntered = false;
    row.shipLines.forEach((r) => {
      if (r.quantityPerBox !== '' && r.quantityPerBox !== undefined && r.quantityPerBox) {
        textEntered = true;
      }
    });
    if (!textEntered) {
      show = false;
    }
    return show;
  }

  totalWeightCal() {
    this.totalWeight = 0;
    let calQuantityWeight = '';
    if (this.reviewOrder.productConfig == 'SKU') {
      for (let o of this.reviewOrder.lines) {
        o.totalWeight = (Number(o.quantityWeight) || 0) * (Number(o.numOfBoxesTmp) || 0);
        this.totalWeight = this.totalWeight + o.totalWeight;
      }
    } else {
      for (let o of this.reviewOrder.lines[0].shipLines) {
        this.singleBoxWeightTemp = (Number(o.boxWeight) || 0);
        this.totalWeight = Number(this.totalWeight) + (Number(this.singleBoxWeightTemp));
      }
    }
  }

  openPackage() {
    this.packagesList = this.package;
  }

  costEstimate() {
    this.reviewOrder.shipLines.forEach((ol) => {
      this.boxHeights = (this.boxHeights > ol.boxHeight ? this.boxHeights : ol.boxHeight);
      this.boxWidths = (this.boxWidths > ol.boxWidth ? this.boxWidths : ol.boxWidth);
      this.boxLengths = (this.boxLengths > ol.boxLength ? this.boxLengths : ol.boxLength);
    });
    if (this.reviewOrder.paymentMethod.toLowerCase() !== 'prepaid') {
      this.reviewOrder.paymentMethod = 'COD';
    }
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
      "accountOwnerId": this.user.accountOwnerId,
      "destPincode": this.reviewOrder.deliveryAreaPinCode,
      "orderType": "PICK",
      "length": this.boxLengths,
      "breadth": this.boxWidths,
      "height": this.boxHeights,
      "paymentMethod": this.reviewOrder.paymentMethod,
      "orderValue": this.reviewOrder.totalValue,
      "organizationId": this.user.organizationId,
      "originPincode": this.reviewOrder.pickupAreaPinCode,
      "weight": this.reviewOrder.weightOfOrder
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.costEstimateList = data;
          this.costEstimation = this.costEstimateList.costEstimateList;
          this.costEstimation.push({
            carrierCode: "Others",
            costEstimates: [{
              id: "",
              carrierCode: "Others",
              shippingPreference: "",
              serviceType: "",
              totalAmount: null,
              estimatedDelivery: "",
              serviceAvailability: ""
            }]
          });
          this.alertService.success('Cost Estimation', 'Submitted successfully');
        } else {
          this.costEstimateList = data;
          this.costEstimation = this.costEstimateList.costEstimateList;
          this.costEstimation.push({
            carrierCode: "Others",
            costEstimates: [{
              id: "",
              carrierCode: "Others",
              shippingPreference: "",
              serviceType: "",
              totalAmount: null,
              estimatedDelivery: "",
              serviceAvailability: ""
            }]
          });
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  removeShipmentLine(r, s) {
    let index = r.shipLines.indexOf(s);
    r.shipLines.splice(index, 1);
    let boxWg = 0;
    r.shipLines.forEach((ele) => {
      if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
        boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
    });
    r.totalQuantity = boxWg;
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }
  }

  shippedDateBlur() {
    this.shippedDateError = "";
    if (!this.shippedDate) {
      this.shippedDateError = "please select shippedDate";
    }
  }

  shipmentCostOtherBlur() {
    this.shipmentCostOtherError = "";
    if (!this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter shipmentCost";
    }
  }


  //packing information api saving functionality

  submitUpdatePackingConfiguration() {

    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updatePackingConfiguration', {
      "accountOwnerId": this.user.accountOwnerId,
      "orderHeaderId": this.reviewOrder.orderHeaderId,
      "orderStatus": "IN_PROCESS",
      "organizationId": 1,
      "productConfig": this.reviewOrder.productConfig,
      "shipLines": this.allShipLines,
      //      "shipmentPrice": this.shippingCost.totalAmount,
      "shippingMethod": "PARCEL",
      //     "shippingOption": this.shippingCost.carrierCode,
      //     "shippingType": this.shipType,
      "totalBoxes": this.totalBoxes || 0
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('OrderProcessing', 'Submitted successfully');
          this.step = 1;
          this.reviewOrder.productConfig = '';
          this.getOrderData();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },

        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }


  selectPackType() {
    this.reviewOrder.lines.forEach((ol) => {
      for (let i = 0; i < ol.shipLines.length; i++) {
        ol.shipLines[i].packageType = this.reviewOrder.lines[0].shipLines[i].packageType;
        ol.shipLines[i].boxLength = this.reviewOrder.lines[0].shipLines[i].boxLength;
        ol.shipLines[i].boxWidth = this.reviewOrder.lines[0].shipLines[i].boxWidth;
        ol.shipLines[i].boxHeight = this.reviewOrder.lines[0].shipLines[i].boxHeight;
        ol.shipLines[i].boxWeight = this.reviewOrder.lines[0].shipLines[i].boxWeight;
      }
    });
    console.log(this.reviewOrder.lines);
  }


  submitOrderForShipment() {
    if (this.shippingCost.deliveryMode == undefined) {
      this.shipType = this.shippingCost.serviceType;
    } else if (this.shippingCost.serviceType == undefined) {
      this.shipType = this.shippingCost.deliveryMode;
    }

    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createShipmentForOrder', {
      "accountOwnerId": this.user.accountOwnerId,
      "orderHeaderId": this.reviewOrder.orderHeaderId,
      "orderStatus": "SUBMITTED",
      "organizationId": 1,
      "shipmentPrice": this.shippingCost.totalAmount,
      "shippingOption": this.shippingCost.carrierCode || "AMAZON_EASYSHIP",
      "shippingType": this.shipType,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('OrderProcessing', 'Submitted successfully');
          if (this.user.role == 'ACCOUNT_OWNER') {
            this.router.navigate(['/admin/orders']);
          } else if (this.user.role == 'AO_SELLER') {
            this.router.navigate(['/admin/sellerOrdersList']);
          }
        } else {
          this.alertService.error('Error', data['message']);
        }

      },

        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }


  submitCreateShipmentForOrder() {

    if (this.shippingCost.deliveryMode == undefined) {
      this.shipType = this.shippingCost.serviceType;
    } else if (this.shippingCost.serviceType == undefined) {
      this.shipType = this.shippingCost.deliveryMode;
    }

    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createShipmentForOrder', {
      "accountOwnerId": this.user.accountOwnerId,
      "orderHeaderId": this.reviewOrder.orderHeaderId,
      "orderStatus": "SUBMITTED",
      "organizationId": 1,
      "shipmentPrice": this.shippingCost.carrierCode == 'Others' ? this.shipmentCostOther : this.shippingCost.totalAmount,
      "shippingMethod": "PARCEL",
      "shippingOption": this.shippingCost.carrierCode == 'Others' ? 'OTHERS' : this.shippingCost.carrierCode,
      "shippingType": this.shipType,
      "carrierName": this.carrierName,
      "trackingNumber": this.AWBNumber,
      "trackingUrl": this.trackingURL,
      "shippedDate": this.datePipe.transform(this.shippedDate, 'MM/dd/yyyy')
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          if (data['channelShippingLabel'] != null) {
            window.open(data['channelShippingLabel'], '_blank');
          }
          this.alertService.success('OrderProcessing', 'Submitted successfully');
          if (this.user.role == 'ACCOUNT_OWNER') {
            this.router.navigate(['/admin/orders']);
          } else if (this.user.role == 'AO_SELLER') {
            this.router.navigate(['/admin/sellerOrdersList']);
          }
        } else {
          this.alertService.error('Error', data['message']);
        }
      },

        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  change() {
    this.numberOfBoxesM = "1";
    for (let sl of this.reviewOrder.lines) {
      sl.numOfBoxesTmp = null;
      sl.qtyPerBoxTmp = null;
      sl.boxHeight = null;
      sl.boxWidth = null;
      sl.boxLength = null;
      sl.boxWeight = null;
      sl.totalQuantity = null;
      sl.quantityWeight = null;
      sl.totalWeight = null;
      sl.packageType = undefined;
      sl.shipLines = [{
        numberOfBoxes: null,
        quantityPerBox: null,
        productId: sl.productId,
        configLineId: this.configLineIdSeq,
        boxHeight: null,
        boxWidth: null,
        boxLength: null,
        boxWeight: null,
        totalQuantity: null
      }];
    }
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  backToShippingConfig() {
  }

  clearFields() {
    this.reviewOrder.productConfig = '';
    this.statusText2 = "";
    for (let o of this.reviewOrder.lines) {
      o.qtyPerBoxTmp = null;
      o.numOfBoxesTmp = null;
      o.boxHeight = null;
      o.boxLength = null;
      o.boxWidth = null;
      o.boxWeight = null;
      o.packageType = undefined,
        o.shipLines = [{
          numberOfBoxes: null,
          quantityPerBox: null,
          productId: o.productId,
          orderLineId: o.orderLineId,
          packageType: undefined,
          boxHeight: null,
          boxWidth: null,
          boxLength: null,
          boxWeight: null,
          totalQuantity: null
        }];
    }
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
  }

  showIcon(row) {
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = Number(totalQuantity) + ((Number(r.quantityPerBox) || 0));
    });
    if (Number(row.quantity) != totalQuantity) {
      show = false;
    }
    return show;
  }

  proceedShipRockForSE() {
    this.statusText10 = '';
    this.statusText11 = '';
    this.statusText12 = '';
    if (this.reviewOrder.productConfig === 'SKU') {
      this.statusText8 = null;
      for (let sl of this.reviewOrder.lines) {
        if (sl.shipLines === null || sl.shipLines === undefined) {
          this.statusText8 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
          return false;
        }
        let totalQuantity = 0;
        sl.shipLines.forEach((r) => {
          totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
        });
        if (sl.quantity != totalQuantity) {
          this.statusText9 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
          return false;
        }
      }
      this.allShipLines = [];
      for (let ol of this.reviewOrder.lines) {
        for (let i = 0; i < ol.shipLines.length; i++) {
          if (!ol.shipLines[i].quantityPerBox || !ol.shipLines[i].numberOfBoxes) {
            // ol.shipLines.splice(i,1);
          } else {
            this.allShipLines.push(ol.shipLines[i]);
          }
        }
      }
    } else {
      this.reviewOrder.lines[0].shipLines.forEach((r) => {
        if (!r.packageType) {
          this.statusText10 = 'Please select package type';
          return false;
        } else if (r.packageType === 'Custom') {
          if (!r.boxHeight || !r.boxWidth || !r.boxLength) {
            this.statusText11 = 'Please enter length, width and height dimentions';
            return false;
          }
        }
      });
      this.reviewOrder.lines.forEach((s) => {
        if (!this.showIcon(s)) {
          this.statusText12 = 'Shipment quantity is not matched';
          return false;
        }
      });
      if (this.statusText10 !== "" || this.statusText11 !== "" || this.statusText12 !== "") {
        return false;
      }
      this.allShipLines = [];
      for (let ol = 0; ol < this.reviewOrder.lines.length; ol++) {
        for (let i = 0; i < this.reviewOrder.lines[ol].shipLines.length; i++) {
          if (!this.reviewOrder.lines[ol].shipLines[i].quantityPerBox) {
            this.reviewOrder.lines[ol].shipLines[i].quantityPerBox = 0;
          }
          if (ol > 0) {
            this.reviewOrder.lines[ol].shipLines[i].boxHeight = this.reviewOrder.lines[0].shipLines[i].boxHeight;
            this.reviewOrder.lines[ol].shipLines[i].boxWidth = this.reviewOrder.lines[0].shipLines[i].boxWidth;
            this.reviewOrder.lines[ol].shipLines[i].boxLength = this.reviewOrder.lines[0].shipLines[i].boxLength;
            this.reviewOrder.lines[ol].shipLines[i].boxWeight = this.reviewOrder.lines[0].shipLines[i].boxWeight;
            this.reviewOrder.lines[ol].shipLines[i].quantityWeight = this.reviewOrder.lines[0].shipLines[i].quantityWeight;
            this.reviewOrder.lines[ol].shipLines[i].totalWeight = this.reviewOrder.lines[0].shipLines[i].totalWeight;
            this.reviewOrder.lines[ol].shipLines[i].boxNumber = this.reviewOrder.lines[0].shipLines[i].boxNumber;
            this.reviewOrder.lines[ol].shipLines[i].qtyPerBox = this.reviewOrder.lines[0].shipLines[i].quantityPerBox;
            this.reviewOrder.lines[ol].shipLines[i].totalQuantity = Number(this.reviewOrder.lines[0].shipLines[i].quantityPerBox) * Number(this.reviewOrder.lines[0].shipLines[i].boxNumber);
          }
        }
        this.allShipLines = [...this.allShipLines, ...this.reviewOrder.lines[ol].shipLines];
      }
    }
    if (this.reviewOrder.productConfig == 'SKU') {
      this.allShipLines.forEach((t) => {
        this.totalBoxes = Number(this.totalBoxes) + Number(t.numberOfBoxes || 0);
      });
    } else {
      this.totalBoxes = Number(this.numberOfBoxesM);
    }
    this.allShipLines.forEach((l) => {
      l.qtyPerBox = l.quantityPerBox || 0;
    });
    console.log(this.reviewOrder.lines);
    console.log(this.reviewOrder);
    this.packingReviewAndConform();
  }

  changeBox() {
    if (this.numberOfBoxes != '') {
      this.reviewOrder.lines.forEach((ol) => {
        ol.shipLines = [];
        for (let i = 1; i <= Number(this.numberOfBoxesM); i++) {
          ol.shipLines.push({
            numberOfBoxes: Number(this.numberOfBoxesM),
            quantityPerBox: 0,
            productId: ol.productId,
            orderLineId: ol.orderLineId,
            configLineId: this.configLineIdSeq,
            boxNumber: i,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          });
        }
      });
    }
    this.defaultValue();
  }


  packingReviewAndConform() {
    this.step = 2;
  }

  reviewAndConfirm() {

    this.carrierNameError = "";
    this.shippedDateError = "";
    this.shipmentCostOtherError = "";

    if (this.others == true && !this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }

    if (this.others == true && !this.shippedDate) {
      this.shippedDateError = "please enter carrierName";
    }

    if (this.others == true && !this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter carrierName";
    }

    if (this.carrierNameError != "" || this.shippedDateError != "" || this.shipmentCostOtherError != "") {
      return false;
    }
    this.step = 2;
  }

  submit() {
    this.step = 1;
  }

  selectCost(c) {
    this.others = false;
    this.othersDisplay = "";
    this.shippingCost = c;
    this.othersDisplay = "";
    if (this.shippingCost.carrierCode == "Others") {
      this.others = true;
      this.othersDisplay = "Others";
    }
  }

  closePopUp() {
    this.statusText13 = '';
    this.statusText14 = '';
    this.printInvoicePopUp = 'N';
    this.creditBalancePopup = 'N';
    this.amount = '';
    this.amountError = '';
  }

  SkipInvoice() {
    this.enterInvoiceReason();
    if (this.statusText13 != '') {
      return false;
    }
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/skipEndCustomerInvoiceGeneration', {
      "accountOwnerId": this.user.accountOwnerId,
      "orderHeaderId": this.reviewOrder.orderHeaderId,
      "cancelReason": this.invoiceReason,
      "organizationId": this.user.organizationId,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.printInvoicePopUp = 'N';
          this.alertService.success('Invoice', 'Skipped successfully');
          if (this.reviewOrder.channelName == "FLIPKART") {
            this.step = 2;
          } else {
            this.tabClicked = 'carrier';
            this.costEstimate();
          }
        } else {
          this.alertService.error(data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  enterInvoiceReason() {
    this.statusText13 = '';
    if (this.invoiceReason === null || this.invoiceReason === undefined || this.invoiceReason === '' || this.invoiceReason === 'undefined') {
      this.statusText13 = 'Please enter Reason';
    }
  }

  defaultValue() {
    for (let r of this.reviewOrder.lines) {
      if (r.quantity == 1) {
        for (let b of this.reviewOrder.lines[0].shipLines) {
          b.quantityPerBox = r.quantity;
        }
      }
    }
  }

  getSlotsList() {
    this.api.getAmazonSlots(this.reviewOrder.orderHeaderId, this.reviewOrder.organizationId).subscribe((data: any) => {
      this.slotsList = data.listPickupSlotsResult.pickupSlots;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  selectShipList(s) {
    this.shippingList = s;
  }

  submitOrderForEasyShip() {
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/bookAmazonSLot', {
      "orderId": this.reviewOrder.orderHeaderId,
      "organizationId": this.reviewOrder.organizationId,
      "pickupTimeEnd": this.shippingList.pickupTimeEnd,
      "pickupTimeStart": this.shippingList.pickupTimeStart,
      "slotId": this.shippingList.slotId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('OrderProcessing', 'Submitted successfully');
          this.submitOrderForShipment();
        } else {
          this.alertService.error('Error', data['message']);
          this.submitOrderForShipment();
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  getCreditAmount() {
    this.statusText14 = "";
    this.api.getCreditTransactionAmount().subscribe((data: any) => {
      this.getCreditsAmount = data;
      if (this.getCreditsAmount > 500) {
        this.submitCreateShipmentForOrder();
      } else {
        this.statusText14 = "Minimum credit balance of ₹500 required";
      }
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  addCreditBalPopup() {
    this.creditBalancePopup = 'Y';
  }

  typeAmount() {
    if (this.amount == '' || this.amount === null || this.amount === undefined || this.amount === 'undefined') {
      this.amountError = 'Please enter Amount';
    }
  }

  submitCreditBal() {
    if (this.amount == '' || this.amount === null || this.amount === undefined || this.amount === 'undefined') {
      this.amountError = 'Please enter Amount';
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/paymentForCODOrderInRazorPay?accountOwnerId=' + this.user.accountOwnerId + '&amount=' + this.amount, null,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        this.razorPayData = data;
        if (data['code'] == 200) {
          this.alertService.success('orderId', data['message']);
          this.razorPayData = data;
          let options: any = {
            "key": environment.razorPayKey, // Enter the Key ID generated from the Dashboard
            "amount": this.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "image": "https:\/\/cdn.razorpay.com\/logos\/JmSlJFpcTpYP3H_medium.png",
            "order_id": this.razorPayData.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1,
            "theme": {
              "color": "#EE7125"
            }
          };
          options.handler = ((response: any, error: any) => {
            options.response = response;
            console.log("response::" + response);
            this.updateSuccessfulPayment(response);
          });

          const rzp1 = new this.payService.nativeWindow.Razorpay(options);
          rzp1.open();
          rzp1.on('payment.failed', (response: any) => {
            this.updateFailurePayment(response);
          });

        } else {

        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  updateSuccessfulPayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCreditTransactionForRazorPay', {
      "razorPayOrderId": response.razorpay_order_id,
      "razorPayPaymentId": response.razorpay_payment_id,
      "razorPaySignature": response.razorpay_signature,
      "response": "SUCCESS"
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.closePopUp();
        this.alertService.success('Payment Success', data['message']);
      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  updateFailurePayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCreditTransactionForRazorPay', {
      "errorCode": response.error.code,
      "errorDescription": response.error.description,
      "errorSource": response.error.source,
      "errorReason": response.error.reason,
      "errorStep": response.error.step,
      "razorPayOrderId": response.error.metadata.order_id,
      "razorPayPaymentId": response.error.metadata.payment_id,
      "response": "FAILURE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.closePopUp();
          this.alertService.success('Payment Failed', data['message']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
